var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabletIcon = function SvgTabletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.15 23H2.85c-.756 0-1.48-.26-2.014-.723C.3 21.815 0 21.19 0 20.536V2.464c0-.653.301-1.28.836-1.741C1.37.26 2.094 0 2.85 0h13.3c.756 0 1.48.26 2.014.723.535.462.835 1.088.836 1.741v18.072c0 .653-.301 1.28-.836 1.741-.534.462-1.258.722-2.014.723ZM2.85 1.643c-.252 0-.493.087-.671.24a.77.77 0 0 0-.279.581v18.072c0 .217.1.426.279.58.178.154.42.24.671.241h13.3c.252 0 .493-.087.671-.24a.77.77 0 0 0 .279-.581V2.464a.77.77 0 0 0-.279-.58 1.031 1.031 0 0 0-.671-.241H2.85Z"
  })));
};
export default SvgTabletIcon;